<template>
  <div class="wrapper">
    <div class="multrans_popup_wrap">
      <div class="multrans_popup_container row">
        <div class="position-relative form-group col-12">
          <label class="col-12 mb-0 p-0">Shop Name*</label>
          <input class="form-control mt-2" type="text" :value="data.name" @change.stop.prevent="store.commit('name', $event.target.value)" />
        </div>
        <div class="position-relative form-group col-6 pr-2">
          <label class="col-12 mb-0 p-0">Code*</label>
          <input name="code" type="text" class="form-control mt-2" :value="integration.api.code" @change.stop.prevent="store.commit('integration.api.code', $event.target.value)" />
        </div>
        <div class="position-relative form-group col-6 pr-2">
          <label class="col-12 mb-0 p-0">Access Token</label>
          <input name="code" type="text" class="form-control mt-2" :value="integration.api.access_token" @change.stop.prevent="store.commit('integration.api.access_token', $event.target.value)" placeholder="No change" />
        </div>

        <!-- Shipping Address Fields -->
        <div class="position-relative form-group col-12 mt-3 mb-0">
          <h6 class="col-12 mb-3 p-0">Shipping Address</h6>
        </div>

        <div class="position-relative form-group col-6 pr-2">
          <label class="col-12 mb-0 p-0">Name*</label>
          <input class="form-control mt-2" type="text" :value="data.shipping_address?.name" @change.stop.prevent="store.commit('shipping_address.name', $event.target.value)" />
        </div>

        <div class="position-relative form-group col-6 pl-2">
          <label class="col-12 mb-0 p-0">Country*</label>
          <input class="form-control mt-2" type="text" :value="data.shipping_address?.country" @change.stop.prevent="store.commit('shipping_address.country', $event.target.value)" />
        </div>

        <div class="position-relative form-group col-6 pr-2">
          <label class="col-12 mb-0 p-0">Phone*</label>
          <input class="form-control mt-2" type="text" :value="data.shipping_address?.phone" @change.stop.prevent="store.commit('shipping_address.phone', $event.target.value)" />
        </div>

        <div class="position-relative form-group col-6 pl-2">
          <label class="col-12 mb-0 p-0">Province*</label>
          <input class="form-control mt-2" type="text" :value="data.shipping_address?.province" @change.stop.prevent="store.commit('shipping_address.province', $event.target.value)" />
        </div>

        <div class="position-relative form-group col-6 pr-2">
          <label class="col-12 mb-0 p-0">City*</label>
          <input class="form-control mt-2" type="text" :value="data.shipping_address?.city" @change.stop.prevent="store.commit('shipping_address.city', $event.target.value)" />
        </div>

        <div class="position-relative form-group col-6 pl-2">
          <label class="col-12 mb-0 p-0">Zip Code*</label>
          <input class="form-control mt-2" type="text" :value="data.shipping_address?.zipcode" @change.stop.prevent="store.commit('shipping_address.zipcode', $event.target.value)" />
        </div>

        <div class="position-relative form-group col-12">
          <label class="col-12 mb-0 p-0">Address*</label>
          <input class="form-control mt-2" type="text" :value="data.shipping_address?.address" @change.stop.prevent="store.commit('shipping_address.address', $event.target.value)" />
        </div>

        <div class="position-relative form-group col-12">
          <label class="col-12 p-0">Calculation file</label>
          <div class="upload-file">
            <label for="upload-file" class="btn btn-outline-success cursor-pointer mb-0">From file</label>
            <input id="upload-file" type="file" @input="changeExcelFile" />
          </div>
          <p class="mb-0">
            <small>
              File used to calculate orders
              <strong>
                <span v-if="integration.api.file">: {{ integration.api.file.name }}</span>
              </strong>
            </small>
          </p>
          <p class="mb-0">
            <small>
              <span> If you do not have a sample, please download </span>
              <a @click.prevent="clickDownloadTemplate" href="#">it here</a>
              <span> or the </span>
              <a @click.prevent="clickDownloadLatestCalculationFile" href="#">latest calculation file</a>.
            </small>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Event from '@/helper/event.js'
import { utils, writeFileXLSX } from 'xlsx'

export default {
  mixins: [Event],
  computed: {
    action() {
      return this.config?.action
    },
    storeId() {
      return this.config?.storeId
    },
    accountId() {
      return this.config?.accountId
    },
    submitUri() {
      return `carrier-account/update/${this.accountId}`
    },
    data() {
      return this.store.getter('', {})
    },
    integration() {
      return _.mergeLeft(
        {
          api: {
            token: ''
          }
        },
        this.data.integration || {}
      )
    }
  },
  mounted() {
    this.$emitter.on('Modal.CarrierAccount.Edit.Submit', this.submit)
  },
  unmounted() {
    this.$emitter.off('Modal.CarrierAccount.Edit.Submit', this.submit)
  },
  methods: {
    changeExcelFile(e) {
      let file = e.target.files[0]
      this.store.commit('integration.api.file', file)
    },
    clickDownloadTemplate() {
      let workbook = utils.book_new()
      let calculateData = [
        ['Total Weight', 'Total Width', 'Total Height', 'Total Length', 'Total Price', 'Product Code'],
        [
          { t: 'n', v: 3, f: 'SUM(J4:J53)' },
          { t: 'n', v: 3, f: 'SUM(K4:K53)' },
          { t: 'n', v: 3, f: 'SUM(L4:L53)' },
          { t: 'n', v: 3, f: 'SUM(M4:M53)' },
          { t: 'n', v: 3, f: 'SUM(N4:N53)' },
          { t: 'n', v: 3, f: 'D4' }
        ],
        ['SKU', 'Quantity', 'Name', 'Product Code', 'Weight', 'Width', 'Height', 'Length', 'Price', 'Sub-Weight', 'Sub-Width', 'Sub-Height', 'Sub-Length', 'Sub-Price']
      ]
      for (let i = 4; i < 54; i++) {
        calculateData.push([
          '', // SKU List
          '', // Quantity
          { t: 'n', v: 3, f: `IFERROR(VLOOKUP($A${i},Data!$A$2:$I$1000,2,FALSE),"")` }, //Name
          { t: 'n', v: 3, f: `IFERROR(VLOOKUP($A${i},Data!$A$2:$I$1000,3,FALSE),"")` }, //Product Code
          { t: 'n', v: 3, f: `IFERROR(VLOOKUP($A${i},Data!$A$2:$I$1000,4,FALSE),"")` }, //Weight
          { t: 'n', v: 3, f: `IFERROR(VLOOKUP($A${i},Data!$A$2:$I$1000,5,FALSE),"")` }, //Width
          { t: 'n', v: 3, f: `IFERROR(VLOOKUP($A${i},Data!$A$2:$I$1000,6,FALSE),"")` }, //Height
          { t: 'n', v: 3, f: `IFERROR(VLOOKUP($A${i},Data!$A$2:$I$1000,7,FALSE),"")` }, //Length
          { t: 'n', v: 3, f: `IFERROR(VLOOKUP($A${i},Data!$A$2:$I$1000,8,FALSE),"")` }, //Price
          { t: 'n', v: 3, f: `IFERROR(E${i},"")` }, //Sub-Weight
          { t: 'n', v: 3, f: `IFERROR(F${i},"")` }, //Sub-Length
          { t: 'n', v: 3, f: `IFERROR(G${i},"")` }, //Sub-Width
          { t: 'n', v: 3, f: `IFERROR(B${i}*H${i},"")` }, //Sub-Height
          { t: 'n', v: 3, f: `IFERROR(B${i}*I${i},"")` } //Sub-Price
        ])
      }

      utils.book_append_sheet(workbook, utils.aoa_to_sheet(calculateData), 'Calculate')
      utils.book_append_sheet(workbook, utils.aoa_to_sheet([['SKU List', 'Name', 'Product Code', 'Weight', 'Width', 'Height', 'Length', 'Price']]), 'Data')

      writeFileXLSX(workbook, `Calculate-${this.data.name}.xlsx`)
    },
    clickDownloadLatestCalculationFile() {
      this.$emitter.emit('Modal.CarrierAccount.Edit.DownloadLatestCalculationFile')
    },
    submit(data) {
      this.submitForm(
        data,
        {
          done: () => {
            this.$emitter.emit('TableList.Refresh')
            this.$emit('close')
          }
        },
        {
          contentType: 'params'
        }
      )
    }
  },
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
body.page-carrier-account {
  .upload-file #upload-file {
    display: none;
  }
}
</style>
